export default "__VITE_ASSET__8IUcf_UG__"